// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"74c60951","396":"0030bfec","455":"25d0c513","857":"86ac3bd4","977":"be092bf9"}[chunkId] + ".chunk.js";
};